import { cssVariables } from "@/utils/utils";
import { Button, Flex } from "antd";
import { useTranslation } from "react-i18next";
import AntIcon from "../../../../../../common/components/icons/AntIcon";
import Ellipsis from "../../../../../../common/components/views/Ellipsis";
import { CommissionsSettingsRankBase } from "../../../../../commissions/ranks/types";
import styles from "../../statistics/DashboardStatisticsWidget.module.scss";
import { StatNumber } from "./common/StatNumber";
import { STATS_HEIGHT } from "./common/utils";

type Props = {
  data: {
    currentRank: CommissionsSettingsRankBase;
    nextRankCriteriaCount: number;
  };
};

export const RankData = ({ data }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <Flex align="center">
        <Button className={styles.labelIcon} variant="filled" color="gold" icon={<AntIcon type="crown" />} />

        <Ellipsis style={{ flex: 1 }}>
          <span style={{ fontSize: 21, paddingLeft: 8 }}>{data.currentRank.name}</span>
        </Ellipsis>
      </Flex>

      <Flex justify="center" align="center" className="margin-top-tiny" style={{ height: STATS_HEIGHT }}>
        <Flex align="end">
          <StatNumber value={data.nextRankCriteriaCount} />

          <div style={{ paddingLeft: 8, lineHeight: "34px" }}>{t("dashboard.statisticsExtended.helpers.points")}</div>
        </Flex>
      </Flex>

      <Ellipsis style={{ color: cssVariables.colorGrey, textAlign: "center" }}>
        {t("dashboard.statisticsExtended.helpers.toNextRank")}
      </Ellipsis>
    </>
  );
};
